import { Culligan } from '@culligan-iot/domain';
import { NonEmptyReadonlyArray } from 'effect/Array';
import LogoCulligan from '@/assets/logo-culligan.svg';
import FaviconCulligan from '@/assets/favicon-culligan.png';
import LogoThinkWater from '@/assets/logo-think-water.svg';
import FaviconThinkWater from '@/assets/favicon-think-water.png';

export interface TenantConfig {
  name: string;
  hostname: string;
  title: string;
  logoUrl: string;
  faviconUrl: string;
  features: {
    trainingMaterials: boolean;
    releaseNotes: boolean;
    consumables: boolean;
    deviceModels: 'all' | NonEmptyReadonlyArray<Culligan.Device.Class.Device['constructor']['code']>;
  };
}

export const CULLIGAN = {
  name: 'culligan',
  hostname: 'culliganiot.com',
  title: 'Culligan One',
  logoUrl: LogoCulligan,
  faviconUrl: FaviconCulligan,
  features: {
    trainingMaterials: true,
    releaseNotes: true,
    consumables: true,
    deviceModels: 'all',
  },
} as const satisfies TenantConfig;

export const THINK_WATER = {
  name: 'thinkWater',
  hostname: 'iot.thinkwater.com',
  title: 'Think Water',
  logoUrl: LogoThinkWater,
  faviconUrl: FaviconThinkWater,
  features: {
    trainingMaterials: false,
    releaseNotes: false,
    consumables: false,
    deviceModels: [Culligan.Device.Class.SyncRo.SyncRo.code],
  },
} as const satisfies TenantConfig;

export const TENANTS = [CULLIGAN, THINK_WATER] as const satisfies readonly TenantConfig[];
export const DEFAULT_TENANT = CULLIGAN;
